import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { matchOtherValidator } from '../util/auth/match-other.directive';
import { MicrosoftOAuthService } from '../services/microsoft-oauth.service';
import { GoogleOAuthService } from '../services/google-oauth.service';

@Component({
    selector: 'app-setup-account',
    templateUrl: './setup-account.component.html',
    styleUrls: ['./setup-account.component.scss'],
    standalone: false
})
export class SetupAccountComponent implements OnInit {
    setupForm: FormGroup;
    token: string = '';
    userName: string = '';
    userEmail: string = '';
    tokenValid = false;
    tokenChecked = false;
    errorMessage = '';
    successMessage = '';
    submitting = false;
    googleId: string | null = null;
    microsoftId: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        private http: HttpClient,
        private microsoftOAuth: MicrosoftOAuthService,
        private googleOAuth: GoogleOAuthService
    ) {
        this.setupForm = this.fb.group({
            password: ['', [Validators.required, Validators.minLength(8)]],
            confirmpassword: ['', [Validators.required, matchOtherValidator('password')]]
        });
    }

    ngOnInit() {
        this.token = this.route.snapshot.paramMap.get('token') || '';
        this.validateToken();
    }

    validateToken() {
        this.http.get(`${environment.apiUrl}/common/auth/validate-setup-token/${this.token}`)
            .subscribe({
                next: (resp: any) => {
                    this.tokenChecked = true;
                    if (resp.result?.valid) {
                        this.tokenValid = true;
                        this.userName = resp.result.name || '';
                        this.userEmail = resp.result.email || '';
                    } else {
                        this.errorMessage = resp.result?.message || 'Token inválido';
                    }
                },
                error: () => {
                    this.tokenChecked = true;
                    this.errorMessage = 'Error al validar el token';
                }
            });
    }

    async linkGoogle() {
        try {
            const result = await this.googleOAuth.openAuthPopup();
            this.googleId = result.provider_id;
        } catch (error) {
            // user closed popup or error
        }
    }

    async linkMicrosoft() {
        try {
            const result = await this.microsoftOAuth.openAuthPopup();
            this.microsoftId = result.provider_id;
        } catch (error) {
            // user closed popup or error
        }
    }

    onSubmit() {
        if (this.setupForm.invalid || this.submitting) return;

        this.submitting = true;
        this.errorMessage = '';

        const body = {
            token: this.token,
            password: this.setupForm.controls['password'].value,
            google_id: this.googleId,
            microsoft_id: this.microsoftId
        };

        this.http.post(`${environment.apiUrl}/common/auth/setup-password`, body)
            .subscribe({
                next: (resp: any) => {
                    this.submitting = false;
                    if (resp.result?.success) {
                        this.successMessage = '¡Cuenta configurada exitosamente! Redirigiendo al login...';
                        setTimeout(() => this.router.navigate(['/login']), 3000);
                    } else {
                        this.errorMessage = 'Error al configurar la cuenta';
                    }
                },
                error: (err) => {
                    this.submitting = false;
                    this.errorMessage = err.error?.message || 'Error al configurar la cuenta';
                }
            });
    }

    unlinkGoogle() { this.googleId = null; }
    unlinkMicrosoft() { this.microsoftId = null; }
}
